import { SortingType } from 'constants/index';

import { QuotationField } from './types';

export const DEFAULT_SORT = {
    field: QuotationField.QUOTATION_DATE,
    type: SortingType.DESC,
};
